import { getLocalAuthDetails } from '../utils/common.util'
import { loadTimelineStatusList } from '../services/activity.service'

export const loadTimelineStatusQuery = async params => {
	try {
		let payload = {
			...params,
			page_limit: 50,
			page_start: 0,
			...getLocalAuthDetails(),
		}

		let res = await loadTimelineStatusList(payload)
		if (res.data.status === 200) {
			return res.data.response
		}
		return []
	} catch (error) {
		console.error(error)
		return error
	}
}
